<form [formGroup]="formGroup">
  <div class="controls-grid">
    <div class="control-cell">
      <mat-slide-toggle
        formControlName="enabled"
        [matTooltip]="!formGroup.get('enabled').value ? 'Enable Docusign' : 'Disable Docusign'"
        matTooltipShowDelay="500"
      >
        Enable Docusign
      </mat-slide-toggle>
    </div>
    @if (signatureEnabled) {
      <ng-container formGroupName="properties">
        <div
          class="control-cell"
          [matTooltip]="!formGroup.get('enabled').value ? 'Enable Docusign to continue' : 'Respect signing order'"
          matTooltipShowDelay="500"
        >
          <label for="signingOrder">Signing order</label>
          <input id="signingOrder" class="kyloe-checkbox" type="checkbox" formControlName="signingOrder" />
        </div>
        <div
          class="control-cell"
          [matTooltip]="!formGroup.get('enabled').value ? 'Enable Docusign to continue' : 'Respect signing order'"
          matTooltipShowDelay="500"
        >
          <label for="ccFollowsSigningOrder">CC follows signing order</label>
          <input id="ccFollowsSigningOrder" class="kyloe-checkbox" type="checkbox"
                 formControlName="ccFollowsSigningOrder" />
        </div>
        @if (directOutputFileSaveEnabled()) {
          <div
            class="control-cell"
            [matTooltip]="!formGroup.get('enabled').value ? 'Enable Docusign to continue' : 'Allow saving/emailing the output file directly from the Web App, outside of Docusign'"
            matTooltipShowDelay="500"
          >
            <label for="directOutputFileSave">Direct output file save</label>
            <input id="directOutputFileSave" class="kyloe-checkbox" type="checkbox"
                   formControlName="directOutputFileSave" />
          </div>
        }
        @if (isDocMerge) {
          <div
            class="control-cell"
            [matTooltip]="!formGroup.get('enabled').value ? 'Enable Docusign to continue' : 'Template sections in Docusign envelope'"
            matTooltipShowDelay="500"
          >
            <label class="inline-label">Template sections in Docusign envelope</label>
            <mat-select formControlName="combinedOutput">
              <mat-option [value]="false">Separate documents</mat-option>
              <mat-option [value]="true">Combined in one document</mat-option>
            </mat-select>
          </div>
        }
      </ng-container>
    }
  </div>
  @if (signatureEnabled) {
    @if (showSignedOutputFileType && (!isDocMerge || combinedOutput)) {
      <div class="controls-grid controls-grid--continuation">
        <ng-container formGroupName="properties">
          <div
            class="control-cell"
            [matTooltip]="!formGroup.get('enabled').value ? 'Enable Docusign to continue' : 'Signed output file type'"
            matTooltipShowDelay="500"
          >
            <label class="inline-label">Signed output file type</label>
            <mat-select formControlName="signedOutputFileType">
              <mat-option [value]="true">Same as main output file type</mat-option>
              <mat-option [value]="false">Different file type</mat-option>
            </mat-select>
          </div>
        </ng-container>
        @if (!signedOutputFileType) {
          <app-document-destination-filetype
            [documentDestinationOptionsAllowed]="parent?.documentDestinationOptionsAllowed"
            [destinationsForOutputFileType]="parent?.signatureDestinationsForOutputFileType"
            [outputFileTypeSectionFormGroup]="parent?.signatureOutputFileTypeSectionFormGroup"
            [fileTypeOptionsAllowed]="parent?.fileTypeOptionsAllowed"
            [entityType]="parent ? parent.configuration.get('entity').value : null"
            [namespace]="namespace"
            [forSignature]="true"
            (updateDocumentForDestinationType)="parent.updateDocumentForDestinationType($event, parent.signatureOutputFileTypeSectionFormGroup, parent.signatureDestinationsForOutputFileType)"
          >
          </app-document-destination-filetype>
        }
      </div>
    }
  }
  <div class="expander" [ngClass]="signatureEnabled ? 'expand' : ''">
    <div class="sections">
      <div class="section">
        <h3>Recipients</h3>
        <mat-accordion class="example-headers-align">
          <mat-expansion-panel [expanded]="panel === 1" (opened)="setPanel(1)" (afterExpand)="autoFocus1.focus()">
            <mat-expansion-panel-header [ngClass]="{ invalid: !recipientsFormArray.valid }">
              <mat-panel-title>
                <mat-icon class="title-icon" fontIcon="people"></mat-icon>
                Add recipients
                <mat-icon
                  class="required-icon"
                  fontIcon="error_outlined"
                  matTooltip="Information required"
                  matTooltipShowDelay="500"
                ></mat-icon>
                <mat-panel-description> Email addresses and signing order</mat-panel-description>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <ul id="recipients" (cdkDropListDropped)="drop($event)" cdkDropList>
              @if (recipientsFormArray.controls.length === 0) {
                <li class="no-results">Add recipients below</li>
              }
              <ng-container formArrayName="recipients">
                @for (recipient of recipientsFormArray.controls; track $index; let i = $index) {
                  <li cdkDrag>
                    <div class="recipient-details">
                      <mat-icon fontIcon="person"></mat-icon>
                      @if (!recipient.get('editing').value) {
                        {{ recipient.value.name }}
                        @if (recipient.value.email) {
                          <span>
                                <mat-icon fontIcon="email"></mat-icon>
                            {{ recipient.value.email }}
                              </span>
                        }
                        @if (recipient.value.role && config.templates.currentTemplateRoles?.length) {
                          <span>
                                <mat-icon fontIcon="work"></mat-icon>
                            {{ recipient.value.role }}
                              </span>
                        }
                      }
                      @if (recipient.get('editing').value) {
                        <div [formGroupName]="i">
                              <span class="edit-name"
                              ><mat-icon fontIcon="person"></mat-icon
                              ><input formControlName="name" placeholder="e.g. Jane Doe"
                                      (mousedown)="$event.stopPropagation()"
                              /></span>
                          <span class="edit-email"
                          ><mat-icon fontIcon="email"></mat-icon
                          ><input
                            #recipientEmailInput
                            type="text"
                            formControlName="email"
                            placeholder="e.g. Jane.Doe@KyloePartners.com"
                            (mousedown)="$event.stopPropagation()"
                          /></span>
                          @if (config.templates.currentTemplateRoles?.length) {
                            <span class="edit-role" formControlName="role">
                                  <mat-icon fontIcon="work"></mat-icon>
                                  <mat-select class="auto-width small-dropdown with-icon" formControlName="role"
                                              placeholder="Choose role">
                                    @for (role of config.templates.currentTemplateRoles; track $index) {
                                      <mat-option [value]="role">{{ role }}</mat-option>
                                    }
                                  </mat-select>
                                </span>
                          }
                        </div>
                        <mat-icon
                          tabindex="0"
                          [matTooltip]="'Accept changes'"
                          matTooltipShowDelay="500"
                          (click)="acceptRecipientEdits(i)"
                          fontIcon="done"
                        ></mat-icon>
                      }
                    </div>
                    <mat-icon
                      id="edit-item-{{ i }}"
                      (click)="toggleEditRecipient(i)"
                      (keydown.enter)="toggleEditRecipient(i)"
                      (keydown.space)="toggleEditRecipient(i)"
                      [matTooltip]="'Edit recipient'"
                      matTooltipShowDelay="500"
                      tabindex="0"
                      fontIcon="edit"
                    ></mat-icon>
                    <mat-icon
                      id="remove-item-{{ i }}"
                      class="remove"
                      (click)="removeRecipient(i)"
                      (keydown.enter)="removeRecipient(i)"
                      (keydown.space)="removeRecipient(i)"
                      [matTooltip]="'Remove recipient'"
                      matTooltipShowDelay="500"
                      tabindex="0"
                      fontIcon="close"
                    ></mat-icon>
                    <mat-icon
                      id="drag-indicator-{{ i }}"
                      [matTooltip]="'Reorder this recipient'"
                      matTooltipShowDelay="500"
                      fontIcon="drag_indicator"
                    ></mat-icon>
                  </li>
                }
              </ng-container>
            </ul>
            <!--            <span style="background-color: lightgreen">{{formGroup.value | json}} | valid={{formGroup.valid}}, dirty={{formGroup.dirty}}</span>-->
            <aside id="add-recipient">
              <section class="footer-btns">
                <button
                  theme="nav"
                  id="add-person-button"
                  (click)="addPersonButton()"
                  [ngClass]="addPerson ? 'selected' : ''"
                  #autoFocus1
                >
                  Add a Recipient
                  <mat-icon fontIcon="add"></mat-icon>
                </button>
                <button
                  theme="nav"
                  id="add-{{ namespace }}-entity-button"
                  (click)="addEntityButton()"
                  [ngClass]="addEntity ? 'selected' : ''"
                >
                  Add {{ namespace === 'invenias' ? 'an Invenias Person' : 'a ' + namespace + ' Entity' }}
                  <mat-icon fontIcon="add"></mat-icon>
                </button>
              </section>

              @if (addPerson) {
                <app-add-recipient
                  [emailRequired]=false
                  [recipientType]="'person'"
                  [recipientRoles]="config.templates.currentTemplateRoles"
                  (emitAddRecipient)="addRecipient($event)"
                  @transitionNewRecipientInOut
                ></app-add-recipient>
              }
              @if (addEntity) {
                <app-add-recipient
                  [recipientType]="namespace"
                  [recipientRoles]="config.templates.currentTemplateRoles"
                  (emitAddRecipient)="addRecipient($event)"
                  @transitionNewRecipientInOut>
                </app-add-recipient>
              }
            </aside>
          </mat-expansion-panel>

          <mat-expansion-panel [expanded]="panel === 2" (opened)="setPanel(2)" (afterExpand)="autoFocus2.focus()">
            <mat-expansion-panel-header [ngClass]="{ invalid: !emailValid() }">
              <mat-panel-title>
                <mat-icon class="title-icon" fontIcon="email"></mat-icon>
                Email
                <mat-icon
                  fontIcon="error_outlined"
                  class="required-icon"
                  matTooltip="Information required"
                  matTooltipShowDelay="500"
                ></mat-icon>
                <mat-panel-description> Subject and message in your email</mat-panel-description>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="email-fields">
              <div class="email-field">
                <label for="email-subject">Email subject</label>
                <input
                  id="email-subject"
                  name="emailSubject"
                  formControlName="emailSubject"
                  type="text"
                  placeholder="e.g. Documents to sign"
                  #autoFocus2
                />
              </div>
              <div class="email-field">
                <label for="email-body">Email message body</label>
                <textarea id="email-body" formControlName="emailBody" rows="10"></textarea>
              </div>
            </div>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
      <div class="section"
           [matTooltip]="!formGroup.get('enabled').value ? 'Enable Docusign to continue' : ''"
           matTooltipShowDelay="500">
        <h3>Send on behalf of</h3>
        <ng-container formGroupName="properties">
          <div id="sending-on-behalf-of-group" formGroupName="sendingOnBehalfOfOptions">
            <mat-button-toggle-group
              name="sendingOnBehalfOf"
              aria-label="Send on behalf of"
              formControlName="type"
              [hideSingleSelectionIndicator]="true"
            >
              <mat-button-toggle
                [value]="SendingOnBehalfOf.KAD_ACCOUNT"
                matTooltip="Send from the default user connected to Kyloe AwesomeDocs"
                matTooltipShowDelay="500"
                matTooltipPosition="above"
              >Kyloe AwesomeDocs user
              </mat-button-toggle
              >
              <mat-button-toggle
                [value]="SendingOnBehalfOf.DOC_SENDER"
                matTooltip="Send as the user creating the document. Note: the user must have a Docusign account to be able to use this functionality"
                matTooltipShowDelay="500"
                matTooltipPosition="above"
              >Document sender
              </mat-button-toggle
              >
              <mat-button-toggle
                [value]="SendingOnBehalfOf.SPECIFIC_USER"
                matTooltip="Provide an email address for a specific user that this document should always be sent from"
                matTooltipShowDelay="500"
                matTooltipPosition="above"
              >Specific user
              </mat-button-toggle
              >
            </mat-button-toggle-group>
            @if (sendingOnBehalfOfOptionsFormGroup.get('type').value === SendingOnBehalfOf.SPECIFIC_USER) {
              <input
                id="sendingOnBehalfOf"
                name="sendingOnBehalfOf"
                type="text"
                (blur)="emailTrim()"
                placeholder="e.g. Email address of alternative Docusign user"
                formControlName="email"
                #sendingOnBehalfOf
              />
            }
          </div>
        </ng-container>
      </div>
      <div class="section">
        <h3 class="basic-flex-container">
          Docusign account:
          @if (config.loadingSuccess && config.accounts.loading) {
            <span class="loading-spinner spinner-border spinner-border-sm"></span>
          }
          @if (config.accounts.isValid) {
            <span
            ><b>{{ selectedAccountName }}</b></span
            >
          }
          @if (!config.accounts.isValid) {
            <span style="color: red">Invalid Entry</span>
          }
          @if (!config.loadingSuccess) {
            <p>
              <a (click)="openAdv2ConfigComponent()" style="cursor: pointer"
              >To enable, please add Signature Credentials, test and save them</a
              >
            </p>
          }
        </h3>
        @if (config.loadingSuccess) {
          <div>
            @if (!config.accounts.loading) {
              <div>
                <mat-button-toggle-group
                  [disabled]="config.accounts.loading || config.brands.loading"
                  aria-label="Docusign Account Selection"
                  (change)="handleAccountToggle($event)"
                  [(value)]="config.accounts.toggleValue"
                  [hideSingleSelectionIndicator]="true"
                >
                  <mat-button-toggle value="default">Kyloe AwesomeDocs account</mat-button-toggle>
                  <mat-button-toggle value="custom">Specify account</mat-button-toggle>
                </mat-button-toggle-group>
                <span formGroupName="properties" [hidden]="config.accounts.toggleValue !== 'custom'">
                                  <mat-select class="auto-width" formControlName="alternativeAccount"
                                              style="margin-left: 20px" placeholder="Choose account">
                                    @for (account of config.accounts.list; track account.account_id) {
                                      <mat-option [value]="account.account_id">{{
                                          account.account_name
                                        }}</mat-option>
                                    }
                                  </mat-select>
                                </span>
              </div>
            }
          </div>
        }
      </div>
      @if (config.loadingSuccess) {
        <div class="section">
          <h3 class="basic-flex-container">
            Docusign brand:
            @if (config.brands.loading) {
              <span class="loading-spinner spinner-border spinner-border-sm"></span>
            }
            @if (config.brands.isValid) {
              <span
              ><b>{{ selectedBrandName }}</b></span
              >
            }
            @if (!config.brands.isValid) {
              <span style="color: red">Invalid Entry</span>
            }
            @if (!config.brands.loading && !config.brands.list.length) {
              <span style="color: grey">No brands available</span>
            }
          </h3>
          <div>
            @if (!config.brands.loading && config.brands.list.length) {
              <div>
                <mat-button-toggle-group
                  aria-label="Docusign Brand Selection"
                  (change)="handleBrandToggle($event)"
                  [(value)]="config.brands.toggleValue"
                  [hideSingleSelectionIndicator]="true"
                >
                  <mat-button-toggle value="default">Use default brand</mat-button-toggle>
                  <mat-button-toggle value="custom">Specify brand</mat-button-toggle>
                </mat-button-toggle-group>
                <span formGroupName="properties" [hidden]="config.brands.toggleValue !== 'custom'">
                                    <mat-select class="auto-width" formControlName="brandId" style="margin-left: 20px"
                                                placeholder="Choose brand">
                                      @for (brand of config.brands.list; track brand.brandId) {
                                        <mat-option [value]="brand.brandId">{{ brand.brandName }}</mat-option>
                                      }
                                    </mat-select>
                                  </span>
              </div>
            }
          </div>
        </div>
      }
      @if (config.loadingSuccess && !this.isDocMerge) {
        <div class="section">
          <h3>
            Docusign template:
            @if (config.templates.loading) {
              <span class="loading-spinner spinner-border spinner-border-sm"></span>
            }
            @if (config.templates.isValid) {
              <span
              ><b>{{ selectedTemplateName }}</b></span
              >
            }
            @if (!config.templates.isValid) {
              <span style="color: red">Invalid Entry</span>
            }
            @if (!config.templates.loading && !config.templates.list.length) {
              <span style="color: grey">No templates available</span>
            }
            @if (config.templates.toggleValue === 'none' && config.templates.list.length) {
              <span style="color: grey">None</span>
            }
          </h3>
          <br />
          <div>
            @if (!config.templates.loading && config.templates.list.length) {
              <div>
                <mat-button-toggle-group
                  aria-label="Docusign Template Selection"
                  (change)="handleTemplateToggle($event)"
                  [(value)]="config.templates.toggleValue"
                  [hideSingleSelectionIndicator]="true"
                >
                  <mat-button-toggle value="none">None</mat-button-toggle>
                  <mat-button-toggle value="custom">Specify template</mat-button-toggle>
                </mat-button-toggle-group>
                <span formGroupName="properties" [hidden]="config.templates.toggleValue !== 'custom'">
                                      <mat-select class="auto-width" formControlName="templateId"
                                                  style="margin-left: 20px" placeholder="Choose template">
                                        @for (template of config.templates.list; track template.templateId) {
                                          <mat-option [value]="template.templateId">{{ template.name }}</mat-option>
                                        }
                                      </mat-select>
                                      <span style="margin-left: 20px; white-space: nowrap">
                                        <label style="margin-right: 5px">Document Position: </label>
                                        <input type="number" min="0" step="1" id="documentPosition"
                                               name="documentPosition" formControlName="documentPosition" />
                                      </span>
                                    </span>
              </div>
            }
          </div>
        </div>
      }
    </div>
  </div>

  <!--  {{ formGroup.value | json }}-->
</form>
